"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function onMute(event) {
  if (event.mute) {
    this.props.onMute(event);
  } else {
    this.props.onUnmute(event);
  }
}

exports.default = onMute;


//////////////////
// WEBPACK FOOTER
// ./~/react-jw-player/dist/create-event-handlers/on-mute.js
// module id = 1784
// module chunks = 1